import { inject, Injectable } from '@angular/core';

import { ROUTES } from '@core/constants';
import {
  IResponseHttp,
  ReceiptPdfUrl,
  ReceiptPreview,
  ReceiptWithUrl,
} from '@core/models';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class ReceiptsService {
  private readonly api = inject(ApiService);

  async getPreview(orderId: string): Promise<ReceiptPreview> {
    const result = await this.api.get<IResponseHttp>(
      ROUTES.ADMIN_RECEIPT_PREVIEW(orderId),
    );
    return result.payload;
  }

  async getPdfUrl(orderId: string): Promise<ReceiptPdfUrl> {
    const result = await this.api.get<IResponseHttp>(ROUTES.ADMIN_RECEIPT_PDF(orderId));
    return result.payload;
  }

  async markAsPaid(receiptId: string): Promise<ReceiptWithUrl> {
    const result = await this.api.patch<IResponseHttp>(
      ROUTES.ADMIN_RECEIPT_PAY(receiptId),
      {},
    );
    return result.payload;
  }

  /**
   * Abre el PDF del recibo en una pestaña nueva. La pestaña se abre en blanco
   * dentro del clic (si no, el navegador la bloquea por esperar la respuesta)
   * y se redirige cuando llega la URL firmada.
   */
  async openPdf(orderId: string): Promise<boolean> {
    const tab = window.open('', '_blank');

    try {
      const { url } = await this.getPdfUrl(orderId);

      if (tab) {
        tab.opener = null;
        tab.location.href = url;
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
      return true;
    } catch {
      tab?.close();
      return false;
    }
  }
}
